import React from 'react';
import { COLORS } from '@constants';
import { SCRIPT_TAG_STATUS } from '@enums';
import { Icon, Tag } from '@ui';
import { MODE } from '../../constants';
import { StyledText } from '../LineItem/styled';

const StatusBadge = ({ setupKey = '', status, variant = MODE.ACCOUNT }) => {
    const statusLabelMap = {
        [SCRIPT_TAG_STATUS.CONNECTED]: 'Connected',
        [SCRIPT_TAG_STATUS.PENDING]: 'Pending...',
        [SCRIPT_TAG_STATUS.NOT_CONNECTED]: 'Not Set'
    };

    const statusColorMap = {
        [SCRIPT_TAG_STATUS.CONNECTED]: COLORS.$robinBlue,
        [SCRIPT_TAG_STATUS.PENDING]: COLORS.$alert,
        [SCRIPT_TAG_STATUS.NOT_CONNECTED]: COLORS.$tartRed
    };

    const label = statusLabelMap[status] || 'Not Set';
    const color = statusColorMap[status] || COLORS.$tartRed;

    if (variant === MODE.CAMPAIGN) {
        if (status === SCRIPT_TAG_STATUS.CONNECTED) {
            return (
                <StyledText
                    data-e2e={`integrations_${setupKey ? `${setupKey}-` : ''}connected_status`}
                    type='badgeSmall'
                    color={COLORS.$robinBlue}
                >
                    <Icon size='24px' component={() => <Icon.CheckCircleIcon />} />
                    Connected
                </StyledText>
            );
        }

        if (status === SCRIPT_TAG_STATUS.PENDING) {
            return (
                <StyledText
                    data-e2e={`integrations_${setupKey ? `${setupKey}-` : ''}pending_status`}
                    type='badgeSmall'
                    color={COLORS.$alert}
                >
                    <Icon size='24px' component={() => <Icon.PendingCircleIcon />} />
                    Pending...
                </StyledText>
            );
        }

        return (
            <StyledText
                data-e2e={`integrations_${setupKey ? `${setupKey}-` : ''}not-connected_status`}
                type='badgeSmall'
                color={COLORS.$tartRed}
            >
                <Icon size='24px' component={() => <Icon.CloseCircleIcon />} />
                Not Set
            </StyledText>
        );
    }

    return (
        <Tag
            data-e2e={`integrations_${setupKey ? `${setupKey}-` : ''}${
                status === SCRIPT_TAG_STATUS.CONNECTED
                    ? 'connected'
                    : status === SCRIPT_TAG_STATUS.PENDING
                    ? 'pending'
                    : 'not-connected'
            }_status`}
            color={color}
        >
            {label}
        </Tag>
    );
};

export default StatusBadge;
